export default "https://cdn-static.gokick.com/assets/545fd9dea55dc30417fabffa3a2a88024697daac/images/sleep-tangerine.8751d74b530006d7d64194d2bb6c9716.png";